
import React, { useCallback, useContext, useMemo, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

import toast from 'react-hot-toast';
import { useEffect } from 'react';
import axios from 'axios'

import { FaEdit } from 'react-icons/fa';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { CommonContext } from '../../App';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import TableComponent from '../../Components/CommonComponent/Table/Table';
import CancelButton from '../../Components/CommonComponent/Button/CancelButton';
import SaveButton from '../../Components/CommonComponent/Button/SaveButton';
import ContactMarquee from '../../Components/CommonComponent/Table/ContactMarquee';
import api from '../../services/api';
import LoadingSpinner from '../../Components/CommonComponent/loadingSpiner/LoadingSpinner';
import DeleteDataModal from '../../Components/CommonComponent/Modals/DeleteDataModal';

export default function PurchaseTable({ isModal = false, updatedDate, onModalClose, onModalSuccess, entry: modalEntry }) {
  const { t } = useTranslation();
  const heading = t("journal");

  const [salesData, setSalesData] = useState([]);
  const [transportationData, setTransportationData] = useState([]);
  const [loadingData, setLoadingData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [groupedData, setGroupedData] = useState([]);
  const [editingEntry, setEditingEntry] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingEntryKey, setEditingEntryKey] = useState(null);

  //  FIX 1: isInitialLoadRef & isSettingDataRef — Sales/Purchase pattern
  const isInitialLoadRef = useRef(true);
  const isSettingDataRef = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { entry: locationEntry, comeBack } = location.state || {};
  const entry = isModal ? modalEntry : locationEntry;

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const LIMIT = 15;
  const [totalRecoard, setTotalRecoard] = useState(0);

  const { userData, branchId, setTotalPurchase, setPurchasewithItem, dateRange } = useContext(CommonContext);
  const adminId = userData?.user?.id;
  const userRole = userData?.user?.role;

  const [isSaving, setIsSaving] = useState(false);
  const [allLedgers, setAllLedgers] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [allSubGroups, setAllSubGroups] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedJournal, setSelectedJournal] = useState(null);
  const saved = JSON.parse(localStorage.getItem("moreOptionsSettings"));
   const ShowColumnInJournal = saved?.JournalEntry;
  //  FIX 2: lockedFields state — Sales/Purchase pattern
  const [lockedSalesFields, setLockedSalesFields] = useState({
    name: '',
    address: '',
    phone: '',
    ledgerId: '',
    ledgerGroup: '',
    ledgerSubGroup: '',
  });

  const [currentSalesItem, setCurrentSalesItem] = useState({
    items: '',
    quantity: '',
    unit: '',
    unitId: '',
    itemInOut: '',
    rate: '',
    total: '',
    perQuantity: '',
  });

  const [endDate, setEndDate] = useState(dateRange.endDate);

  useEffect(() => {
    setEndDate(dateRange.endDate);
  }, [dateRange.endDate, dateRange.startDate]);

  const [tableFilterModalOpen, setTableFilterModalOpen] = useState(false);
  const [tableFilters, setTableFilters] = useState({
    transportation: true,
    loadingUnloading: true,
  });

  // Auto-focus first input
  useEffect(() => {
    const timer = setTimeout(() => {
      const firstInput = document.querySelector('input[type="text"]');
      if (firstInput) firstInput.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  // Load saved filters
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(`table_filters_${heading}`));
    if (saved) setTableFilters(saved);
  }, [heading]);

  // ─── Meta data fetch ───────────────────────────────────────────────────────

  const fetchLedgerData = useCallback(async () => {
    if (!branchId) return;
    try {
      setLoading(true);
      const res = await api.get(`ledgers/get-all-ledger?branchId=${branchId}&isActive=1`);
      if (res.data.success) {
        setAllLedgers(res.data.allData || []);
        setLedgerData(res.data.allData || []);
      }
    } catch (err) {
      toast.error(err.message || "Failed to fetch ledgers");
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  const fetchGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`groups-types/get-all-group?branchId=${branchId}`);
      if (res.data.success) setAllGroups(res.data.allData || []);
    } catch {
      toast.error("Failed to fetch groups");
    }
  }, [branchId]);

  const fetchSubGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`groups-types/get-all-sub-group?branchId=${branchId}`);
      if (res.data.success) setAllSubGroups(res.data.allData || []);
    } catch {
      toast.error("Failed to fetch subgroups");
    }
  }, [branchId]);

  useEffect(() => {
    if (!branchId) return;
    const loadMeta = async () => {
      setLoading(true);
      await Promise.all([
        fetchLedgerData(),
        fetchGroups(),
        fetchSubGroups(),
      ]);
      setLoading(false);
    };
    loadMeta();
  }, [branchId]);

  // ─── Entry load (edit mode from prop) ─────────────────────────────────────

  useEffect(() => {
    if (!entry) return;

    //  FIX 3: isInitialLoadRef & isSettingDataRef set karo — Sales pattern
    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;

    setEditingEntry(entry);
    if (isModal) {
      setIsEditMode(true);
    }
    setEditingEntryKey(entry.entry_key || entry.purchaseKey);
    setSalesData(entry.fromJournal || []);
    setTransportationData(entry.toJournal || []);
    // setLoadingData(entry.loading || []);

    //  FIX 4: lockedFields set karo — Sales pattern
    if (entry.fromJournal && entry.fromJournal.length > 0) {
      setLockedSalesFields({
        name: entry.fromJournal[0].name || '',
        address: entry.fromJournal[0].address || '',
        phone: entry.fromJournal[0].phone || '',
        ledgerId: entry.fromJournal[0].ledgerId || '',
        ledgerGroup: entry.fromJournal[0].ledgerGroup || '',
        ledgerSubGroup: entry.fromJournal[0].ledgerSubGroup || '',
      });
    }

    setResetKey(prev => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;
    }, 200);
  }, [entry]);

  // ─── Fetch updated entry by key ───────────────────────────────────────────

  useEffect(() => {
    const fetchUpdateSales = async () => {
      //  FIX 5: Correct condition — `||` nahi `&&` (Sales pattern)
      if (!branchId || !entry?.entry_key) return;
      try {
        setLoading(true);
        const res = await api.get(
          `journal/get-journal-by-key?journal_key=${entry.entry_key}&branchId=${branchId}`
        );
        if (res.data.success) {
          isInitialLoadRef.current = true;
          isSettingDataRef.current = true;
          console.log(res.data)

          setIsEditMode(true);
          setEditingEntry(res.data);
          setEditingEntryKey(res.data.purchaseKey);
          setSalesData(res.data.fromJournal || []);
          setTransportationData(res.data.toJournal || []);
          // setLoadingData(res.data.loading || []);

          if (res.data.fromJournal && res.data.fromJournal.length > 0) {
            setLockedSalesFields({
              name: res.data.fromJournal[0].name || '',
              address: res.data.fromJournal[0].address || '',
              phone: res.data.fromJournal[0].phone || '',
              ledgerId: res.data.fromJournal[0].ledgerId || '',
              ledgerGroup: res.data.fromJournal[0].ledgerGroup || '',
              ledgerSubGroup: res.data.fromJournal[0].ledgerSubGroup || '',
            });
          }

          setTimeout(() => {
            isSettingDataRef.current = false;
          }, 200);
        }
      } catch (error) {
        toast.error("Failed to load updated journal data.");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (entry?.entry_key && branchId) {
      fetchUpdateSales();
    }
  }, [entry?.entry_key, branchId]);

  // ─── handleSalesDataChange — FIXED (Sales pattern) ───────────────────────

  //  FIX 6: Completely rewritten — frontendDelete aware, isSettingDataRef aware,
  //           totalQuantity correct, lockedFields set, sync to transportation
  const handleSalesDataChange = useCallback((data) => {
    setSalesData(data);

    if (!data || data.length === 0) return;

    const firstRow = data[0];

    //  Deleted rows exclude karke total quantity
    const totalQuantity = data
      .filter(row => row.frontendDelete !== 0)
      .reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);

    const unit =
      firstRow?.typeOfBricks?.unit ||
      firstRow?.items?.unit ||
      firstRow.unit || '';

    const perQuantity =
      firstRow?.typeOfBricks?.perQuantity ||
      firstRow?.items?.perQuantity ||
      firstRow.perQuantity ||
      firstRow.per_quantity || '';

    setCurrentSalesItem({
      items: firstRow.items || firstRow.typeOfBricks || '',
      quantity: totalQuantity.toString(),
      unit: unit || '',
      unitId: firstRow.unitId || '',
      itemInOut: firstRow.itemInOut || '',
      rate: firstRow.rate || '',
      total: firstRow.total || '',
      perQuantity: perQuantity || '',
    });

    //  lockedFields update — Sales pattern
    const newLockedFields = {
      name: firstRow.name || '',
      address: firstRow.address || '',
      phone: firstRow.phone || '',
      ledgerId: firstRow.ledgerId || '',
      ledgerGroup: firstRow.ledgerGroup || '',
      ledgerSubGroup: firstRow.ledgerSubGroup || '',
    };
    setLockedSalesFields(prev =>
      JSON.stringify(prev) === JSON.stringify(newLockedFields) ? prev : newLockedFields
    );

    //  isSettingDataRef guard
    if (isSettingDataRef.current) return;

    const isInitialLoad = isInitialLoadRef.current;
    if (isInitialLoad) isInitialLoadRef.current = false;

    //  Sync transportation — deleted rows skip
    const syncWithSales = (prevData) => {
      if (!prevData || prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row; // deleted row skip
        if (idx === 0) {
          return {
            ...row,
            items: firstRow.items || row.items || '',
            unit: unit || row.unit || '',
            perQuantity: perQuantity || row.perQuantity || row.per_quantity || '',
            quantity: totalQuantity.toString(),
          };
        }
        return {
          ...row,
          quantity: '0',
        };
      });
    };

    setTransportationData(prev => syncWithSales(prev));
  }, [isEditMode]);

  const handleTransportationDataChange = useCallback((data) => {
    setTransportationData(data);
  }, []);

  const handleLoadingDataChange = useCallback((data) => {
    setLoadingData(data);
  }, []);

  //  FIX 7: handleItemChange — totalQty correct calculate karo (Sales pattern)
  const handleItemChange = useCallback((item, quantity, unit, unitId, itemInOut, rate, total, perQuantity) => {
    // salesData se totalQty — deleted rows exclude
    const totalQty = salesData
      .filter(row => row.frontendDelete !== 0)
      .reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);

    setCurrentSalesItem({
      items: item,
      quantity: totalQty.toString(),
      unit: item?.unit || unit || '',
      unitId: unitId || '',
      itemInOut: itemInOut || '',
      rate: rate || '',
      total: total || '',
      perQuantity: item?.perQuantity || perQuantity || '',
    });

    // Transportation update
    setTransportationData(prevData => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          if (isEditMode) {
            return { ...row, quantity: totalQty.toString() };
          }
          return {
            ...row,
            items: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || '',
          };
        }
        return { ...row, quantity: '0' };
      });
    });

    // Loading update (journal me loading table nahi hai but future proof)
    setLoadingData(prevData => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          if (isEditMode) {
            return { ...row, quantity: totalQty.toString() };
          }
          return {
            ...row,
            items: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || '',
          };
        }
        return { ...row, quantity: '0' };
      });
    });
  }, [salesData, isEditMode]);

  // ─── Columns ───────────────────────────────────────────────────────────────

  const purchaseColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, locked: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
     {  header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text' ,uniqueId:"#phone"},
   ShowColumnInJournal && { header: t('item'), placeholder: 'items', inputType: 'dropdown', options: [], active: true, filteration: true, type: 'text',uniqueId:"#items",columnPart: "Stock" },
   ShowColumnInJournal && { header: t('manageStock'), placeholder: 'itemInOut', inputType: 'dropdown', options: ['None', 'Add', 'Deduct'], active: true, removeAddBtn: true, type: 'text' ,uniqueId:"#manageStock"},
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text',uniqueId:"#description" },
    ShowColumnInJournal &&{ header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number',uniqueId:"#quantity" },
   ShowColumnInJournal && { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text',uniqueId:"#unit" },
   ShowColumnInJournal && { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number',uniqueId:"#rate" },
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number',uniqueId:"#total" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const transportationColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, locked: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
     {  header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text' ,uniqueId:"#phone"},
   ShowColumnInJournal && { header: t('item'), placeholder: 'items', inputType: 'dropdown', options: [], active: true, filteration: true, type: 'text',uniqueId:"#items",columnPart: "Stock" },
   ShowColumnInJournal && { header: t('manageStock'), placeholder: 'itemInOut', inputType: 'dropdown', options: ['None', 'Add', 'Deduct'], active: true, removeAddBtn: true, type: 'text' ,uniqueId:"#manageStock"},
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text',uniqueId:"#description" },
    ShowColumnInJournal &&{ header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number',uniqueId:"#quantity" },
   ShowColumnInJournal && { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text',uniqueId:"#unit" },
   ShowColumnInJournal && { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number',uniqueId:"#rate" },
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number',uniqueId:"#total" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const visibleSelesColumns = useMemo(
    () => purchaseColumns.filter(c => c && c.active && c.status !== 'auto'),
    [purchaseColumns]
  );
  const visibleTransportationColumns = useMemo(
    () => transportationColumns.filter(c => c && c.active && c.status !== 'auto'),
    [transportationColumns]
  );

  // ─── Auto fields ───────────────────────────────────────────────────────────

  const addAutoFields = useCallback((data, columns) => {
    const autoCols = columns.filter(col => col && col.status === 'auto');
    return data.map(row => {
      const updated = { ...row };
      autoCols.forEach(col => {
        updated[col.placeholder] = col.defaultValue;
      });
      return updated;
    });
  }, []);

  const ledgerGroupMappingSales = {
    name: '',
    items: 'Raw Material',
  };
  const ledgerGroupMappingTransporte = {
    name: '',
    items: 'Raw Material',
  };

  const allSavedSalesRows = useMemo(() =>
    finalData.flatMap(entry => entry.fromJournal || []),
    [finalData]
  );
  const allSavedTransporteRows = useMemo(() =>
    finalData.flatMap(entry => entry.toJournal || []),
    [finalData]
  );

  // ─── Data fetch ────────────────────────────────────────────────────────────

  const fetchRealData = useCallback(async (pageNum = 1, reset = false) => {
    if (!branchId || !endDate) return;
    try {
      pageNum === 1 ? setLoading(true) : setLoadingMore(true);
      const res = await api.get(
        `journal/get-journal-entry?branchId=${branchId}&date=${endDate}&page=${pageNum}&limit=${LIMIT}&order=desc`
      );
      if (res.data.success) {
        const newData = res.data.entries || [];
        setTotalRecoard(res.data.total);
        setGroupedData(prev => (reset ? newData : [...prev, ...newData]));
        setHasMore(newData.length === LIMIT);
      }
    } catch (error) {
      toast.error("Failed to load consolidated data.");
      console.error(error);
    } finally {
      setLoadingMore(false);
      setLoading(false);
    }
  }, [branchId, endDate]);

  //  FIX 8: fetchFinalData — setLoading(false) properly in finally
  const fetchFinalData = useCallback(async () => {
    if (!branchId) return;
    try {
      setLoading(true);
      const res = await api.get(`journal/get-all-journal?branchId=${branchId}`);
      if (res.data.success) {
        setFinalData(res.data.entries || []);
        setTotalPurchase(res.data.totalQuantity || 0);
        setPurchasewithItem(res.data.quantityByItems || []);
      }
    } catch (error) {
      toast.error("Failed to load consolidated data.");
      console.error(error);
    } finally {
      setLoading(false); //  FIX: was setLoadingMore(false) before
    }
  }, [branchId, setTotalPurchase, setPurchasewithItem]);

  useEffect(() => {
    if (branchId && endDate) {
      setPage(1);
      setHasMore(true);
      fetchRealData(1, true);
    }
  }, [branchId, endDate, fetchRealData]);

  useEffect(() => {
    if (branchId) fetchFinalData();
  }, [branchId, fetchFinalData]);

  const refreshTable = useCallback(() => {
    setPage(1);
    setHasMore(true);
    fetchRealData(1, true);
  }, [fetchRealData]);

  useEffect(() => {
    if (page > 1) {
      fetchRealData(page);
    }
  }, [page, fetchRealData]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 20 && hasMore && !loadingMore) {
      setPage(prev => prev + 1);
    }
  };

const filterJournalFields = (item) => {
  if (ShowColumnInJournal) return item;

  const {
    quantity,
    unit,
    unitId,
    perQuantity,
    per_quantity,
    rate,
    items,
    itemInOut,
    ...rest
  } = item;

  return rest;
};

  const handleSave = useCallback(async () => {
    const hasValidFromRow = salesData.some(row =>
    row.frontendDelete !== 0 && row.ledgerId
  );
  const hasValidToRow = transportationData.some(row =>
    row.frontendDelete !== 0 && row.ledgerId
  );
  if (!hasValidFromRow) {
    toast.error(t('pleaseSelectLedger') || "Please select a ledger in FROM table");
    return;
  }
  if (!hasValidToRow) {
    toast.error(t('pleaseSelectLedger') || "Please select a ledger in TO table");
    return;
  }
    const purchaseKey = isEditMode ? editingEntryKey : uuidv4();
    setIsSaving(true);
    try {

const salesWithAuto = addAutoFields(salesData, purchaseColumns).map(item => {

  const formattedItem = {
    ...item,
    name: lockedSalesFields.name,
    address: lockedSalesFields.address,
    phone: lockedSalesFields.phone,
    ledgerId: item.ledgerId || lockedSalesFields.ledgerId,
    ledgerGroup: item.ledgerGroup || lockedSalesFields.ledgerGroup,
    ledgerSubGroup: item.ledgerSubGroup || lockedSalesFields.ledgerSubGroup,
    purchase_key: purchaseKey,
    branchId,
    ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
  };

  return filterJournalFields(formattedItem);
});


      const transWithAuto = addAutoFields(transportationData, transportationColumns).map(item => {

  const formattedItem = {
    ...item,
    purcahse_key: purchaseKey,
    branchId,
    per_quantity: item.perQuantity || item.per_quantity || currentSalesItem.perQuantity || '',
    unit: item.unit || currentSalesItem.unit || '',
    ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
  };

  return filterJournalFields(formattedItem);
});
      if (isEditMode) {
        const payload = {
          entryDate: updatedDate || endDate,
          journalKey: purchaseKey,
          fromData: salesWithAuto,
          toData: transWithAuto,
          branchId,
          adminId,
        };

        const updateRes = await api.post(`journal/update-journal-entry`, payload);

        if (updateRes.data.success) {
          if (updateRes.data.data) {
            setFinalData(prev => prev.map(e =>
              e.purchase_key === purchaseKey ? { ...e, ...updateRes.data.data } : e
            ));
            setGroupedData(prev => prev.map(e =>
              e.purchase_key === purchaseKey ? { ...e, ...updateRes.data.data } : e
            ));
          }
          toast.success("Data updated successfully!");
          fetchFinalData();
          refreshTable();

          if (isModal && onModalSuccess) {
            fetchFinalData();
            refreshTable();
            onModalSuccess();
          } else if (comeBack) {
            navigate(comeBack, { state: { entry: updateRes.data.data.fromJournal[0] } });
          }
        }
      } else {
        const payload = {
          entryDate: endDate,
          journalKey: purchaseKey,
          fromData: salesWithAuto,
          toData: transWithAuto,
          branchId,
        };

        const createRes = await api.post(`journal/create-journal-entry`, payload);

        if (createRes.data.success) {
          toast.success('Data saved successfully!');
          fetchFinalData();
          refreshTable();

          if (isModal && onModalSuccess) {
            onModalSuccess();
            fetchFinalData();
            refreshTable();
          } else if (comeBack) {
            navigate(comeBack, { state: { entry } });
          }
        }
      }

      if (isEditMode) {
        await handleCancelEdit();
      } else {
        setResetKey(prev => prev + 1);
        // lockedFields reset
        setLockedSalesFields({
          name: '',
          address: '',
          phone: '',
          ledgerId: '',
          ledgerGroup: '',
          ledgerSubGroup: '',
        });
      }

      setTimeout(() => {
        const firstInput = document.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }, 100);

    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to save data.";
      toast.error(backendMessage);
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  }, [
    isModal, onModalSuccess, isEditMode, editingEntryKey,
    addAutoFields, salesData, purchaseColumns,
    transportationData, transportationColumns,
    lockedSalesFields, currentSalesItem,
    branchId, adminId, updatedDate, endDate,
    comeBack, navigate, entry,
    fetchFinalData, refreshTable,
  ]);

  // ─── Edit / Cancel ─────────────────────────────────────────────────────────

  const handleEditEntry = useCallback((entry) => {
   
    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;
    // console.log(entry)
    setEditingEntry(entry);
    setIsEditMode(true);
    setEditingEntryKey(entry.purchaseKey);
      const fromData = [...(entry.fromJournal || [])].reverse();
      const toData = [...(entry.toJournal || [])].reverse();
  
  setSalesData(fromData);
  setTransportationData(toData);
    

    if (entry.fromJournal && entry.fromJournal.length > 0) {
      setLockedSalesFields({
        name: entry.fromJournal[0].name || '',
        address: entry.fromJournal[0].address || '',
        phone: entry.fromJournal[0].phone || '',
        ledgerId: entry.fromJournal[0].ledgerId || '',
        ledgerGroup: entry.fromJournal[0].ledgerGroup || '',
        ledgerSubGroup: entry.fromJournal[0].ledgerSubGroup || '',
      });
    }

    setResetKey(prev => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;
    }, 200);
  }, []);

const handleCancelEdit = useCallback(() => {
  return new Promise(resolve => {
    //  FIX: pehle editingEntry null karo, phir resetKey badlao
    setEditingEntry(null);
    setIsEditMode(false);
    setEditingEntryKey(null);
    setSalesData([]);
    setTransportationData([]);
    setLoadingData([]);
    setLockedSalesFields({
      name: '',
      address: '',
      phone: '',
      ledgerId: '',
      ledgerGroup: '',
      ledgerSubGroup: '',
    });

    isInitialLoadRef.current = true;
    isSettingDataRef.current = false;

    //  FIX: resetKey ko setTimeout mein badlao taaki editingEntry=null pehle apply ho
    setTimeout(() => {
      setResetKey(prev => prev + 1);
    }, 0);

    if (isModal && onModalClose) {
      onModalClose();
    } else if (comeBack) {
      navigate(comeBack, { state: { entry } });
    }

    setTimeout(() => {
      const firstInput = document.querySelector('input[type="text"]');
      if (firstInput) firstInput.focus();
      resolve();
    }, 50);
  });
}, [isModal, onModalClose, comeBack, navigate, entry]);

  const handleDeleteJournalApi = async (entry) => {
    try {
      const res = await api.post("journal/delete-journal-entry", {
        journalKey: entry.purchaseKey,
        branchId,
        adminId,
        role: userRole,
        deleteReason: entry.deleteReason,
        deletePassword: entry.deletePassword,
        entry,
      });

      if (res.data.success) {
        toast.success("Journal entry deleted successfully");
        setShowDeleteModal(false);
        setSelectedJournal(null);
        refreshTable();
        fetchFinalData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
    }
  };

  // ─── Render ────────────────────────────────────────────────────────────────

  return (
    <div className="text-center">
      <div className="w-full">
        <div className="w-full">

          {/* FROM TABLE */}
          <div className="pt-2">
            <TableComponent
              columns={visibleSelesColumns}
              onUpdateData={fetchLedgerData}
              allLedgers={allLedgers}
              setAllLedgers={setAllLedgers}
              ledgerData={ledgerData}
              setLedgerData={setLedgerData}
              allGroups={allGroups}
              allSubGroups={allSubGroups}
              setAllGroups={setAllGroups}
              setAllSubGroups={setAllSubGroups}
              heading={t("from")}
                tableUniqueId='#journal_from_table'
              tableFilteration={false}
              uniqueForFilter="fromJournalData"
              onDataChange={handleSalesDataChange}
              resetTrigger={resetKey}
              allowMultiple={true}
              suggestionsData={allSavedSalesRows}
              firstInputPlaceholder="name"
              finalData={finalData}
              calculateTotal={true}
              perQuantityRate="1"
              field="name"
              changeDesignHeading={false}
              defaultLedgerGroup=""
              columnLedgerGroups={ledgerGroupMappingSales}
              //  FIX: lockedFields pass karo
              lockedFields={lockedSalesFields}
              isMasterTable={true}
              tableFilterModalOpen={tableFilterModalOpen}
              setTableFilterModalOpen={setTableFilterModalOpen}
              tableFilters={tableFilters}
              setTableFilters={setTableFilters}
              syncedUnit={currentSalesItem.unit}
              createDyanamicAccount={false}
              //  FIX: isSettingDataRef pass karo
              isSettingDataRef={isSettingDataRef}
              isEditMode={isEditMode}
              showValidationError={(message) => toast.error(message)}
              skipItemValidation={true} 
              //  FIX: onItemChange pass karo
              onItemChange={handleItemChange}
              onLastInputEnter={() => {
                setTimeout(() => {
                  const buttons = document.querySelectorAll('button');
                  const saveBtn = Array.from(buttons).find(btn =>
                    btn.textContent.toLowerCase().includes('save') ||
                    btn.textContent.toLowerCase().includes('processing')
                  );
                  if (saveBtn) saveBtn.focus();
                }, 100);
              }}
              {...(editingEntry ? { initialData: editingEntry.fromJournal } : {})}
            />
          </div>

          {/* TO TABLE */}
          <div className="pt-1">
            <TableComponent
              columns={visibleTransportationColumns}
              onUpdateData={fetchLedgerData}
              allLedgers={allLedgers}
              setAllLedgers={setAllLedgers}
              ledgerData={ledgerData}
              setLedgerData={setLedgerData}
              allGroups={allGroups}
              allSubGroups={allSubGroups}
              setAllGroups={setAllGroups}
              setAllSubGroups={setAllSubGroups}
              heading={t("to")}
              tableUniqueId='#journal_to_table'
              tableFilteration={false}
              uniqueForFilter="ToJournalData"
              onDataChange={handleTransportationDataChange}
              resetTrigger={resetKey}
              allowMultiple={true}
              calculateTotal={true}
              perQuantityRate="1"
              part="journal"
              suggestionsData={allSavedTransporteRows}
              finalData={finalData}
              firstInputPlaceholder="name"
              field="name"
              changeDesignHeading={false}
              //  FIX: synced props correctly pass karo
              syncedItem={currentSalesItem.items}
              syncedQuantity={currentSalesItem.quantity}
              syncedUnit={currentSalesItem.unit}
              syncedUnitId={currentSalesItem.unitId}
              syncedRate={currentSalesItem.rate}
              syncedItemInOut={currentSalesItem.itemInOut}
              syncedTotal={currentSalesItem.total}
              syncedPerQuantity={currentSalesItem.perQuantity}
              defaultLedgerGroup=""
              columnLedgerGroups={ledgerGroupMappingTransporte}
              createDyanamicAccount={false}
              //  FIX: isSettingDataRef pass karo
              isSettingDataRef={isSettingDataRef}
              isEditMode={isEditMode}
              showValidationError={(message) => toast.error(message)}
              skipItemValidation={true} 
              {...(editingEntry ? { initialData: editingEntry.toJournal } : {})}
            />
          </div>

        </div>

        {/* Save / Cancel */}
        <div className="flex justify-end gap-2 mt-2">
          <CancelButton onClick={handleCancelEdit} text={t('cancel')} />
          <SaveButton
            onClick={(e) => {
              if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
                handleSave();
              }
            }}
            text={isSaving ? t('processing') : t('save')}
            disabled={isSaving}
            className="save-button"
          />
        </div>

        {/* Loading spinner */}
        {loading && (
          <div className="flex justify-center items-center w-full py-10">
            <div className="flex justify-center my-4">
              <LoadingSpinner size={70} />
            </div>
          </div>
        )}

        {/* Data table */}
        {!loading && !isModal && !onModalClose && (
          groupedData.length > 0 ? (
            <div>
              <div
                className="overflow-x-auto lg:overflow-visible mt-2 max-h-[80vh] overflow-y-auto relative custom-scrollbar"
                onScroll={handleScroll}
              >
                <table className="w-full table-auto border-separate border-spacing-0 overflow-hidden">
                  <thead>
                    <tr className="bg-theme-headerBg text-theme-color">
                      <th colSpan={4} className="border-e py-[2px] text-center font-medium text-sm">{t('from')}</th>
                      <th colSpan={4} className="py-[2px] text-center font-medium text-sm">{t('to')}</th>
                    </tr>
                    <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg">
                      <th className="border-b border-e px-1 text-center font-medium text-sm w-12">{t('srNumber')}</th>
                      <th className="border-b px-2 py-[2px] text-start font-medium text-sm">{t('name')}</th>
                      <th className="border-b px-1 py-[2px] text-start font-medium text-sm">{t('description')}</th>
                      <th className="border-b border-e text-center font-medium text-sm">
                        {ShowColumnInJournal && t('qty')} {ShowColumnInJournal && t('unit')} {ShowColumnInJournal && t('item')} {ShowColumnInJournal && `@` } {ShowColumnInJournal && t('rate')} {ShowColumnInJournal && t('perQty')}  {ShowColumnInJournal && `=` } {t('total')}
                      </th>
                      <th className="border-b px-2 text-start font-medium text-sm">{t('name')}</th>
                        <th className="border-b px-1 py-[2px] text-start font-medium text-sm">{t('description')}</th>
                      <th className="border-b border-e px-1 text-center font-medium text-sm">
                             {ShowColumnInJournal && t('qty')} {ShowColumnInJournal && t('unit')} {ShowColumnInJournal && t('item')} {ShowColumnInJournal && `@` } {ShowColumnInJournal && t('rate')} {ShowColumnInJournal && t('perQty')}  {ShowColumnInJournal && `=` } {t('total')}
                      </th>
                      <th className="border-b px-1 text-center font-medium text-sm">{t('actions')}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {groupedData.map((entry, idx) => (
                      <tr key={entry.purchaseKey} className="align-center bg-theme-tableBg">

                        <td className="border-b border-e text-center font-bold align-middle text-sm w-12">
                          {totalRecoard - idx}
                        </td>

                        <td className="border-b break-words px-1 text-sm cursor-pointer">
                          {entry.fromJournal.map((row, i) => (
                            <div className="text-sm flex flex-col" key={i}>
                              <div
                                className="text-center p-0 cursor-pointer"
                                title="Check account details"
                                onClick={() => navigate('/account-books/ledger-details', {
                                  state: { purchaseRegister: row, comeBack: "/dashboard/journal-entry" }
                                })}
                              >
                                <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                  <ContactMarquee firstName={row.name} secondName={row.cousinName} />
                                </div>
                                <div className="flex gap-2 justify-center w-32 capitalize">
                                  <ContactMarquee firstName={row.ledgerSubGroup} secondName={row.subGroupNameInHindi} />
                                </div>
                              </div>
                              <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll custom-scrollbar cursor-pointer capitalize">
                                <ContactMarquee firstName={row.phone} secondName={row.address} />
                              </div>
                                    <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(row.balance.closing_balance).toLocaleString('en-IN')} {row.balance.closing_balance !== 0 ? `(${row.balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                            </div>
                          ))}
                        </td>
                            <td className="border-b break-words text-start px-1 text-sm cursor-pointer">
                          {entry.fromJournal.map((row, i) => (
                            <div className="text-sm flex flex-col w-32" key={i}>
                              {row.description}
                            </div>
                          ))}
                        </td>

                        <td className="border-b border-e text-center text-sm p-0">
                         {entry.fromJournal.map((row, i) => (
                            <div key={i} className="m-0 p-0">
                              {ShowColumnInJournal && row.quantity > 0 && Number(row.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal && row.unit && row.unit} {ShowColumnInJournal &&   row.items ? row.items.name : ''} {ShowColumnInJournal && row.quantity > 0 && `@`}{ShowColumnInJournal &&  row.rate > 0 && Number(row.rate).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal &&  row.rate > 0 && row.rate && "/"}{ShowColumnInJournal &&  row.quantity > 0 && Number(row.per_quantity ? row.per_quantity : 1).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal &&  row.quantity > 0 && `=`}  {row.total > 0 && Number(row.total).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                              {i < entry.fromJournal.length - 1 && <hr className="my-1" />}
                            </div>
                          ))}
                        </td>

                        <td
                          className="border-b text-center text-sm px-[2px] cursor-pointer"
                          title="Check account details"
                        >
                          {entry.toJournal.map((row, i) => (
                            <div
                              key={i}
                              onClick={() => navigate('/account-books/ledger-details', {
                                state: { purchaseRegister: row, comeBack: "/dashboard/journal-entry" }
                              })}
                            >
                              <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                <ContactMarquee firstName={row.name} secondName={row.cousinName} />
                              </div>
                              <div className="flex gap-2 justify-center w-32 capitalize">
                                <ContactMarquee firstName={row.ledgerSubGroup} secondName={row.subGroupNameInHindi} />
                              </div>
                              <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                <ContactMarquee firstName={row.phone} secondName={row.address} />
                              </div>
                                   <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(row.balance.closing_balance).toLocaleString('en-IN')} {row.balance.closing_balance !== 0 ? `(${row.balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                              {i < entry.toJournal.length - 1 && <hr className="my-1" />}
                            </div>
                          ))}
                        </td>
                              <td className="border-b break-words text-start px-1 text-sm cursor-pointer">
                          {entry.toJournal.map((row, i) => (
                            <div className="text-sm flex flex-col w-28" key={i}>
                              {row.description}
                            </div>
                          ))}
                        </td>

                        <td className="border-b border-e text-center px-1 text-sm p-0">
                          {entry.toJournal.map((row, i) => (
                                   <div key={i} className="m-0 p-0">
                              {ShowColumnInJournal && row.quantity > 0 && Number(row.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal && row.unit && row.unit} {ShowColumnInJournal &&   row.items ? row.items.name : ''} {ShowColumnInJournal && row.quantity > 0 && `@`}{ShowColumnInJournal &&  row.rate > 0 && Number(row.rate).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal &&  row.rate > 0 && row.rate && "/"}{ShowColumnInJournal &&  row.quantity > 0 && Number(row.per_quantity ? row.per_quantity : 1).toLocaleString("en-US", { maximumFractionDigits: 0 })} {ShowColumnInJournal &&  row.quantity > 0 && `=`}  {row.total > 0 && Number(row.total).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                              {i < entry.toJournal.length - 1 && <hr className="my-1" />}
                            </div>
                          ))}
                        </td>

                        <td className="border-b text-center align-middle">
                          <div className="flex justify-center gap-2">
                            <FaEdit
                              className="text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                              onClick={async () => {
                                await handleCancelEdit();
                                handleEditEntry(entry);
                              }}
                              title="Edit journal"
                            />
                            <RiDeleteBin6Fill
                              className="text-red-700 mt-1 cursor-pointer hover:text-red-800 transition-colors"
                              title="Delete journal entry"
                              onClick={() => {
                                setSelectedJournal(entry);
                                setShowDeleteModal(true);
                              }}
                            />
                          </div>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>

                {loadingMore && (
                  <div className="flex justify-center py-3">
                    <LoadingSpinner size={30} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <p className='text-sm text-gray-600'>{t('noDataAvailable')}</p>
          )
        )}
      </div>

      {showDeleteModal && (
        <DeleteDataModal
          selectedLedger={selectedJournal}
          handleDeleteModalClose={() => {
            setShowDeleteModal(false);
            setSelectedJournal(null);
          }}
          handleDeleteLedgerApi={handleDeleteJournalApi}
          showinputFields={true}
        />
      )}
    </div>
  );
}